var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { sm: "6", xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: "Naam" },
                            model: {
                              value: _vm.value.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "name", $$v)
                              },
                              expression: "value.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "6", xs: "12" } },
                        [
                          _c("app-select-tier", {
                            attrs: { fancy: "" },
                            model: {
                              value: _vm.value.tier,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "tier", $$v)
                              },
                              expression: "value.tier",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: "Workspace URL" },
                            model: {
                              value: _vm.value.workspaceUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "workspaceUrl", $$v)
                              },
                              expression: "value.workspaceUrl",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              fancy: "",
                              label: "Flexibele abonnementsprijs",
                            },
                            model: {
                              value: _vm.value.FixedRenewalPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "FixedRenewalPrice", $$v)
                              },
                              expression: "value.FixedRenewalPrice",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "6", xs: "12" } },
                        [
                          _c("w-date-picker", {
                            attrs: { fancy: "", label: "Aangemaakt op" },
                            model: {
                              value: _vm.value.dateCreated,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "dateCreated", $$v)
                              },
                              expression: "value.dateCreated",
                            },
                          }),
                          _c("w-date-picker", {
                            attrs: {
                              disabled: _vm.permanentlyActive,
                              fancy: "",
                              label: "Actief tot",
                            },
                            model: {
                              value: _vm.value.activeUntil,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "activeUntil", $$v)
                              },
                              expression: "value.activeUntil",
                            },
                          }),
                          _c("w-date-picker", {
                            staticClass: "mt",
                            attrs: {
                              disabled: _vm.permanentServicePack,
                              nullable: true,
                              fancy: "",
                              label: "Service Pack tot",
                            },
                            model: {
                              value: _vm.value.servicePackExpirationDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value,
                                  "servicePackExpirationDate",
                                  $$v
                                )
                              },
                              expression: "value.servicePackExpirationDate",
                            },
                          }),
                          _c("w-date-picker", {
                            staticClass: "mt",
                            attrs: {
                              nullable: "",
                              fancy: "",
                              label: "Datum eerste betaling",
                            },
                            model: {
                              value: _vm.value.dateFirstActivation,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "dateFirstActivation", $$v)
                              },
                              expression: "value.dateFirstActivation",
                            },
                          }),
                          _c("w-input", {
                            staticClass: "mt",
                            attrs: {
                              fancy: "",
                              label: "WinFakt! Offline Klnr.",
                            },
                            model: {
                              value: _vm.value.WfOfflineID,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "WfOfflineID", $$v)
                              },
                              expression: "value.WfOfflineID",
                            },
                          }),
                          _c("app-select-discovered-us-from", {
                            staticClass: "mt",
                            attrs: {
                              label: "Winfakt ontdekt via",
                              "discovered-us-from": _vm.discoveredUsFrom,
                              "empty-text": "Niet ingevuld",
                              fancy: "",
                            },
                          }),
                          _c("w-multi-select", {
                            staticClass: "mt",
                            attrs: {
                              label: "Klant komt origineel van",
                              fancy: "",
                              "empty-text": "Niet ingevuld",
                              items: _vm.accountCreatedByItems,
                              value: _vm.accountCreatedByValue,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setAccountCreatedBy($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "6", xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              value: _vm.permanentlyActive,
                              label: "Permanent actief",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.togglePermanentlyActive()
                              },
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: {
                              value: _vm.permanentServicePack,
                              label: "Permanent Service Pack",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.togglePermanentServicePack()
                              },
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: { label: "Is Demo" },
                            model: {
                              value: _vm.value.isDemo,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "isDemo", $$v)
                              },
                              expression: "value.isDemo",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: { label: "Is geblokkeerd?" },
                            model: {
                              value: _vm.value.Blocked,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "Blocked", $$v)
                              },
                              expression: "value.Blocked",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: { label: "Werknemers account" },
                            model: {
                              value: _vm.value.employeeAccount,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "employeeAccount", $$v)
                              },
                              expression: "value.employeeAccount",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: { label: "Heeft een review geschreven" },
                            model: {
                              value: _vm.value.hasWrittenReview,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "hasWrittenReview", $$v)
                              },
                              expression: "value.hasWrittenReview",
                            },
                          }),
                          _c("w-checkbox", {
                            staticClass: "mt",
                            attrs: { label: "Gevraagd om review te schrijven" },
                            model: {
                              value: _vm.value.askedForReview,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "askedForReview", $$v)
                              },
                              expression: "value.askedForReview",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { sm: "6", xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              fancy: "",
                              label: "Betaal frequentie",
                              items: _vm.paymentFrequencyItems,
                            },
                            model: {
                              value: _vm.value.paymentFrequency,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "paymentFrequency", $$v)
                              },
                              expression: "value.paymentFrequency",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-company-did-not-purchase-reason", {
                            attrs: {
                              fancy: "",
                              label: "Reden van geen aankoop",
                            },
                            model: {
                              value: _vm.didNotPurchaseReasons,
                              callback: function ($$v) {
                                _vm.didNotPurchaseReasons = $$v
                              },
                              expression: "didNotPurchaseReasons",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-textarea", {
                            attrs: {
                              label: "Reden van geen aankoop extra",
                              fancy: "",
                            },
                            model: {
                              value: _vm.didNotPurchaseReasonExplained,
                              callback: function ($$v) {
                                _vm.didNotPurchaseReasonExplained = $$v
                              },
                              expression: "didNotPurchaseReasonExplained",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.isInfo
                ? _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "mr",
                          on: {
                            click: function ($event) {
                              return _vm.resetModules()
                            },
                          },
                        },
                        [_vm._v(" Standaard modules instellen ")]
                      ),
                      _c(
                        "w-dropdown",
                        {
                          staticClass: "mr",
                          attrs: {
                            disabled: _vm.isBeingMoved || !_vm.isAdmin,
                            icon: "chevron-down",
                            items: _vm.moveDbItems,
                          },
                          on: {
                            click: function ($event) {
                              return $event()
                            },
                          },
                        },
                        [
                          _vm.isBeingMoved
                            ? _c("w-progress-circular", {
                                staticClass: "mr",
                                attrs: { multiplier: 0.3, color: "white" },
                              })
                            : _vm._e(),
                          _vm._v(
                            " Overzetten van database " +
                              _vm._s(_vm.value.DbID + 1) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-dropdown",
                        {
                          attrs: {
                            disabled: _vm.isBeingMoved || !_vm.isAdmin,
                            icon: "chevron-down",
                            items: _vm.moveDbItemsQueued,
                          },
                          on: {
                            click: function ($event) {
                              return $event()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " Overzetten van database uitgesteld " +
                              _vm._s(_vm.value.DbID + 1) +
                              " "
                          ),
                        ]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.saveCompany()
                            },
                          },
                        },
                        [_vm._v(" Bewaren ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [_c("app-company-edit-vars", { attrs: { value: _vm.value } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }